<template>
  <div class="wrapper" :class="!$isCN() && 'wrapper-en'">
    <div class="root">
      <div class="date">{{ date }}</div>
      <div class="txt">{{ txt }}</div>
      <div class="ph" />
      <www-picture class="img" w="248" h="149" :img="img" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    date: String,
    txt: String,
    img: String,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 280px;
  padding: 4px;
}
.root {
  background: linear-gradient(180deg, #f1f3f8 0%, #ffffff 100%);
  box-shadow: 1px 2px 6px #f4f1f0;
  border-radius: 2px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 32px 16px 16px 16px;
  box-sizing: border-box;
  height: 100%;

  .date {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    text-align: justify;
    color: #2b2c2e;
  }

  .txt {
    margin-top: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    // height: 40px;
    white-space: pre-line;
    color: #2b2c2e;
  }

  .img {
    margin-top: 10px;
    height: 149px;
    width: 248px;
    flex-shrink: 0;
    object-fit: contain;
    overflow: hidden;
  }
}
.wrapper-en {
  .txt {
    // height: ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryItemMob.vue